import { FC } from 'react'

import { Grid } from 'components'
import { EditIcon, DeleteIcon } from 'components/Icons'
import { SPACING } from 'utils'

import { ISelectedData } from '../../AreaCollapse'
import {
  TableContainerStyled,
  TableStyled,
  TableHeadStyled,
  TableRowStyled,
  TableCellStyled,
  TableBodyStyled
} from './AreaTable.styles'
interface IAreaTable {
  tableData: ISelectedData[]
  selectedData: (objReq: any, type: 'D' | 'E') => void
}
export const AreaTable: FC<IAreaTable> = ({ tableData, selectedData }) => (
  <Grid
    gridCols="3fr 5fr"
    gridGap={`0 ${SPACING.spacing10}`}
    margin={`0 0 ${SPACING.spacing30} 0`}
  >
    <TableContainerStyled>
      <TableStyled stickyHeader>
        <TableHeadStyled>
          <TableRowStyled>
            <TableCellStyled minwidth="18em">Área</TableCellStyled>
            <TableCellStyled>Ações</TableCellStyled>
          </TableRowStyled>
        </TableHeadStyled>
        <TableBodyStyled>
          {tableData?.map((row) => (
            <TableRowStyled key={row.idAreaConsolidacao.toString()}>
              <TableCellStyled>{row.dsAreaConsolidacao}</TableCellStyled>
              <TableCellStyled>
                <EditIcon
                  onClick={() => selectedData(row, 'E')}
                  marginRight={SPACING.spacing15}
                />
                <DeleteIcon
                  cursor="pointer"
                  onClick={() => selectedData(row, 'D')}
                />
              </TableCellStyled>
            </TableRowStyled>
          ))}
        </TableBodyStyled>
      </TableStyled>
    </TableContainerStyled>
  </Grid>
)
